module.exports = __webpack_public_path__ + "img/manual4.63775ece.png";